import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
import { common_axios } from "../../../../App";
import { toast, ToastContainer } from "react-toastify";
import CheckBox from "../../Reacttable/UserManagement/ReactTableFiles/CheckBox";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import TableViewIcon from "@mui/icons-material/TableView";
import Swal from "sweetalert2";
import PersonIcon from "@mui/icons-material/Person";

import {
  Backdrop,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import Loader from "../../../../components/Loader";
import { SettingsInputComponent } from "@mui/icons-material";
import { dateFormatter } from "../../../../helper/helper";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import { useLocation } from "react-router-dom/";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
export default function ViewUserTemplate({ id }) {
  const customId1 = "custom-id-yes";
  const [data3, setData3] = useState([]);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [count, setCount] = useState();
  const [selectionRange, setSelectionRange] = useState(0);
  // console.log("id--", id);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);

  const [filter, setFilter] = useState({
    templateType: null,
    approveType: 1,
    type: null,
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
    selectorType: null,
  });

  const fetchUser = async () => {
    try {
      setOpen(true);
      if (
        filter.type != null ||
        (filter.resellerName != "" && filter.resellerName != null)
      ) {
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/search/templete`,
          {
            approved: filter.approveType,
            templateName: filter.resellerName,
            category: filter.type,
            pageNo: filter.pageNo,
            pageSize: filter.pageSize,
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          setData(res.data?.listOfTemplate?.content);
          setData3(res.data?.listOfTemplate);
          setOpen(false);
        } else if (res.data.statusDescription.statusCode == 220) {
          setData([]);
          setOpen(false);
        } else {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else {
        setOpen(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/user/templete/find`,
          {
            category: filter.type,
            approved: filter.approveType,
            // userId:
            //   JSON.parse(localStorage.getItem("Sidebaritems")).name ==
            //   "ROLE_RESELLER"
            //     ? null
            //     : localStorage.getItem("UserId"),
            userId: id,
            createdBy: null,
            templateName: null,
            templateType: filter.templateType,
            resellerId:
              JSON.parse(localStorage.getItem("Sidebaritems")).name ==
              "ROLE_RESELLER"
                ? localStorage.getItem("UserId")
                : null,
            pageNo: filter.pageNo,
            pageSize: filter.pageSize,
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          setData(res.data.listOfTemplate.content);
          setData3(res.data.listOfTemplate);

          setOpen(false);
        } else if (res.data.statusDescription.statusCode == 220) {
          setData([]);
          setOpen(false);
        } else {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
      // console.log(error);
    }
  };

  const resellerCount = async () => {
    try {
      setOpen(true);
      const res = await common_axios(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/users/templates/count?uid=${id}`
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        let obj = {};
        for (
          let index = 0;
          index < res?.data?.templateStatusList.length;
          index++
        ) {
          const element = res?.data?.templateStatusList[index];

          if (element?.status == 0) {
            obj["pending"] = element?.count;
          }

          if (element?.status == 1) {
            obj["success"] = element?.count;
          }
          if (element?.status == 2) {
            obj["failed"] = element?.count;
          }
        }
        setCount(obj);
      } else if (res.data.statusDescription.statusCode == 220) {
        setOpen(false);
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescription.statusMessage, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(() => {
    if (id != undefined) {
      resellerCount();
    }
  }, [id, filter]);
  //   useEffect(()=>{
  //     resellerCount();
  //   },[])

  useEffect(() => {
    if (id != undefined) {
      fetchUser();
    }
  }, [filter.approveType, filter.pageNo, filter.pageSize, id]);

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);

  const modelButtonApprove = useRef(null);
  const modelButtonApprove1 = useRef(null);

  const approveUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove.current.click();
  };
  const approveUserModal1 = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove1.current.click();
  };

  const textareaRef = useRef();

  const enterVal = async () => {
    let textToInsert = "#var#";

    let cursorPosition = await selectionRange;
    let textBeforeCursorPosition = await textareaRef.current.value.substring(
      0,
      cursorPosition
    );

    let textAfterCursorPosition = await textareaRef.current.value.substring(
      cursorPosition,
      textareaRef.current.value.length
    );

    if (textBeforeCursorPosition.slice(-1) != " ") {
      setSelectedUserDetailApprove({
        ...selectedUserDetailApprove,
        templateDescription:
          textBeforeCursorPosition +
          " " +
          textToInsert +
          textAfterCursorPosition,
      });
    } else {
      setSelectedUserDetailApprove({
        ...selectedUserDetailApprove,
        templateDescription:
          textBeforeCursorPosition + textToInsert + textAfterCursorPosition,
      });
    }

    // textareaRef.current.value =
    //   textBeforeCursorPosition + " " + textToInsert + textAfterCursorPosition;

    // setVariableUsed([...variableUsed, textToInsert]);

    // textareaRef.current.focus();
  };

  const onBlur = async (e) => {
    await setSelectionRange(e.target.selectionStart);
  };

  const columns = useMemo(
    () =>
      JSON.parse(localStorage.getItem("Sidebaritems")).name == "ROLE_RESELLER"
        ? [
      
            {
              Header: "Id",
              accessor: "id",
              Cell: (cell) => (
                <>
                  {cell.row.index +
                    1 +
                    filter?.pageNo * filter?.pageSize}
                </>
              ),
            },
            // {
            //   Header: "DLT PE Id",

            //   accessor: "dltId", // accessor is the "key" in the data
            // },

            // {
            //   Header: "Template DltId",

            //   accessor: "templateDltId", // accessor is the "key" in the data
            // },
            {
              Header: "Template Name",

              accessor: "templateName", // accessor is the "key" in the data
            },
            {
              Header: "Category",

              accessor: "category", // accessor is the "key" in the data
            },
            // {
            //   Header: "Template Type",

            //   accessor: "templateType", // accessor is the "key" in the data
            // },

            {
              Header: "Date",

              accessor: "creationDate",
              // Cell: (cell) => {
              //   return <>{dateFormatter(cell.row.original.creationDate)}</>;
              // },
            },

            {
              Header: "Status",

              accessor: "approved",
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.approved == 0 ? (
                      <div className="badge badge_8 bg-warning">Pending</div>
                    ) : cell.row.original.approved == 1 ? (
                      <div className="badge badge_8 bg-success">Approved</div>
                    ) : (
                      <div className="badge badge_8 bg-danger">Rejected</div>
                    )}
                  </>
                );
              },
            },
            {
              Header: "Language",

              accessor: "lang", // accessor is the "key" in the data
            },
            {
              Header: "Unicode",

              accessor: "unicode", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.unicode == 0 ? (
                      <CancelIcon color="red" sx={{ color: "red" }} />
                    ) : (
                      <CheckCircleIcon color="green" sx={{ color: "green" }} />
                    )}
                  </>
                );
              },
            },

            {
              Header: "Created By",

              accessor: "createdBy",
            },
            {
              Header: "Created For",

              accessor: "createdFor",
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.createdFor ? (
                      <>{cell.row.original.createdFor}</>
                    ) : (
                      <>{cell.row.original.createdBy}</>
                    )}
                  </>
                );
              },
            },

            {
              Header: "Action",

              accessor: "action",
              Cell: (cell) => (
                <div className="dropdown">
                  <button
                    className="btn color_1 dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="material-icons opacity-10 size">person</i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    {/* <li
                onClick={() => {
                  console.log(cell);
                }}
              >
                <a
                  className="dropdown-item"
                  onClick={() => {
                    rejectUserModal(cell);
                  }}
                >
                  Reject
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  onClick={() => {
                    approveUserModal(cell);
                  }}
                >
                  Approve
                </a>
              </li> */}
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          approveUserModal(cell);
                        }}
                      >
                        {cell.row.original.approved == 0 ? (
                          <>Edit template</>
                        ) : (
                          <> View Details</>
                        )}
                      </a>
                    </li>

                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          approveUserModal1(cell);
                        }}
                      >
                        Delete
                      </a>
                    </li>
                  </ul>
                </div>
              ),

              disableFilters: true,
            },
          ]
        : [
          {
            Header: "Id",
            accessor: "id",
            Cell: (cell) => (
              <>
                {cell.row.index +
                  1 +
                  filter?.pageNo * filter?.pageSize}
              </>
            ),
          },

            // {
            //   Header: "DLT PE Id",

            //   accessor: "dltId", // accessor is the "key" in the data
            // },

            // {
            //   Header: "Template DltId",

            //   accessor: "templateDltId", // accessor is the "key" in the data
            // },
            {
              Header: "Template Name",

              accessor: "templateName", // accessor is the "key" in the data
            },
            {
              Header: "Category",

              accessor: "category", // accessor is the "key" in the data
            },
            // {
            //   Header: "Template Type",

            //   accessor: "templateType", // accessor is the "key" in the data
            // },

            {
              Header: "Date",

              accessor: "creationDate",
              // Cell: (cell) => {
              //   return <>{dateFormatter(cell.row.original.creationDate)}</>;
              // },
            },

            {
              Header: "Status",

              accessor: "approved",
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.approved == 0 ? (
                      <div className="badge badge_8 bg-warning">Pending</div>
                    ) : cell.row.original.approved == 1 ? (
                      <div className="badge badge_8 bg-success">Approved</div>
                    ) : (
                      <div className="badge badge_8 bg-danger">Rejected</div>
                    )}
                  </>
                );
              },
            },
            {
              Header: "Language",

              accessor: "lang", // accessor is the "key" in the data
            },
            {
              Header: "Unicode",

              accessor: "unicode", // accessor is the "key" in the data
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.unicode == 0 ? (
                      <CancelIcon color="red" sx={{ color: "red" }} />
                    ) : (
                      <CheckCircleIcon color="green" sx={{ color: "green" }} />
                    )}
                  </>
                );
              },
            },
            {
              Header: "Created By",

              accessor: "createdBy",
            },

            {
              Header: "Action",

              accessor: "action",
              Cell: (cell) => (
                <div className="dropdown">
                  <button
                    className="btn color_1 dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="material-icons opacity-10 size">person</i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    {/* <li
                onClick={() => {
                  console.log(cell);
                }}
              >
                <a
                  className="dropdown-item"
                  onClick={() => {
                    rejectUserModal(cell);
                  }}
                >
                  Reject
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  onClick={() => {
                    approveUserModal(cell);
                  }}
                >
                  Approve
                </a>
              </li> */}
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          approveUserModal(cell);
                        }}
                      >
                        {cell.row.original.approved == 0 ? (
                          <>Edit template</>
                        ) : (
                          <> View Details</>
                        )}
                      </a>
                    </li>

                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          approveUserModal1(cell);
                        }}
                      >
                        Delete
                      </a>
                    </li>
                  </ul>
                </div>
              ),

              disableFilters: true,
            },
          ],
    [filter]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const rejectUserApi = async (e) => {
    e.preventDefault();
    const buttonn = document.getElementById("close_edit");
    try {
      buttonn.click();
      setOpen(true);

      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/template/v1/update`,
        selectedUserDetailApprove

        // {
        //   approved: setSelectedUserDetailApprove?.approved,
        //   id: setSelectedUserDetailApprove?.id,
        //   userId: setSelectedUserDetailApprove?.userId,
        //   dltId: setSelectedUserDetailApprove?.dltId,
        //   templateDltId: setSelectedUserDetailApprove?.templateDltId,
        //   telemarketerId: setSelectedUserDetailApprove?.telemarketerId,
        //   templateName: setSelectedUserDetailApprove?.templateName,
        //   templateDescription:
        //     setSelectedUserDetailApprove?.templateDescription,
        //   category: setSelectedUserDetailApprove?.category,
        //   createdBy: setSelectedUserDetailApprove?.createdBy,
        //   status: setSelectedUserDetailApprove?.status,
        // }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        fetchUser();
        // await toast.success("Template Details Updated Successfully", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "Template Details Updated Successfully",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescription.statusMessage, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          //  title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const approveUserApi = async (e) => {
    // e.preventDefault();
    const buttonn = document.getElementById("close_edit");
    try {
      buttonn?.click();
      setOpen(true);

      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/template/v1/update`,
        // selectedUserDetailApprove

        {
          approved: 3,
          id: selectedUserDetailApprove?.id,
          userId: selectedUserDetailApprove?.userId,
          dltId: selectedUserDetailApprove?.dltId,
          templateDltId: selectedUserDetailApprove?.templateDltId,
          telemarketerId: selectedUserDetailApprove?.telemarketerId,
          templateName: selectedUserDetailApprove?.templateName,
          templateDescription: selectedUserDetailApprove?.templateDescription,
          category: selectedUserDetailApprove?.category,
          createdBy: selectedUserDetailApprove?.createdBy,
          status: true,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);

        // await toast.success("Template Deleted Successfully", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "Template Deleted Successfully",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        fetchUser();
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          //  title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      {selectedUserDetailApprove != undefined && (
        <>
          <button
            type="button"
            ref={modelButtonApprove}
            class="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            Launch static backdrop modal
          </button>

          <form onSubmit={rejectUserApi}>
            <div
              class="modal fade"
              id="staticBackdrop"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">
                      View Details
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div className="modal-body">
                    {/* <div className="row">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          DLT PE Id:
                        </label>

                        <input
                          className="form-control"
                          placeholder="DLT PE Id Here"
                          type="number"
                          minLength="3"
                          disabled={selectedUserDetailApprove?.approved != 0}
                          value={selectedUserDetailApprove?.dltId}
                          onChange={(e) => {
                            setSelectedUserDetailApprove({
                              ...selectedUserDetailApprove,
                              dltId: e.target.value,
                            });
                          }}
                        />
                      </div>

                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Template DltId
                        </label>
                        <input
                          className="form-control"
                          placeholder="Template DltId Here"
                          type="number"
                          minLength="3"
                          disabled={selectedUserDetailApprove?.approved != 0}
                          value={selectedUserDetailApprove?.templateDltId}
                          onChange={(e) => {
                            setSelectedUserDetailApprove({
                              ...selectedUserDetailApprove,
                              templateDltId: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div> */}

                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Created By:
                        </label>

                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailApprove?.createdBy}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>

                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Template Name
                        </label>
                        <input
                          disabled={selectedUserDetailApprove?.approved != 0}
                          className="form-control"
                          placeholder="Telemarketer Id Here"
                          type="text"
                          minLength="3"
                          value={selectedUserDetailApprove?.templateName}
                          onChange={(e) => {
                            setSelectedUserDetailApprove({
                              ...selectedUserDetailApprove,
                              templateName: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          Category
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailApprove?.category}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          Created On
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailApprove?.createdOn}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          Language
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailApprove?.lang}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          Unicode
                        </label>
                        <input
                          type="text"
                          disabled
                          value={
                            selectedUserDetailApprove?.unicode == 0
                              ? false
                              : true
                          }
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-md-12">
                        <label className="text-start">Template</label>

                        {selectedUserDetailApprove?.templateType !=
                          "Dynamic" && (
                          <TextareaAutosize
                            className="form-control w-100"
                            value={
                              selectedUserDetailApprove?.templateDescription
                            }
                            onChange={(e) => {
                              if (
                                selectedUserDetailApprove?.lang == "English"
                              ) {
                                if (
                                  /^[a-zA-Z0-9!@~#$%^&*()-_+=\[\]{};:'",.<>/?\\| ]*$/.test(
                                    e.target.value
                                  )
                                ) {
                                  setSelectedUserDetailApprove({
                                    ...selectedUserDetailApprove,
                                    templateDescription: e.target.value,
                                  });
                                }
                              } else {
                                setSelectedUserDetailApprove({
                                  ...selectedUserDetailApprove,
                                  templateDescription: e.target.value,
                                });
                              }
                            }}
                            disabled={selectedUserDetailApprove?.approved != 0}
                            name="templateDesc"
                            fullWidth
                            aria-label="minimum height"
                            minRows={5}
                            //   style={{ minHeight: "150px" }}

                            placeholder="Enter Template"
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer justify-content-between">
                    <button
                      type="button"
                      id="close_edit"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    {selectedUserDetailApprove?.approved == 0 && (
                      <button type="submit" className="btn btn-primary">
                        Update
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </>
      )}

      {selectedUserDetailApprove != undefined && (
        <div>
          <button
            ref={modelButtonApprove1}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop1"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdrop1Label"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdrop1Label">
                    Are you sure you want to delete?
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setSelectedUserDetailApprove(null);
                    }}
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="row mt-2">
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Created By:
                      </label>

                      <input
                        type="text"
                        disabled
                        value={selectedUserDetailApprove?.createdBy}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>

                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Template Name
                      </label>
                      <input
                        disabled
                        className="form-control"
                        placeholder="Telemarketer Id Here"
                        type="text"
                        minLength="3"
                        value={selectedUserDetailApprove?.templateName}
                      />
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-md-6 mt_2">
                      <label for="exampleInputEmail1" className="form-label">
                        Category
                      </label>
                      <input
                        type="text"
                        disabled
                        value={selectedUserDetailApprove?.category}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="col-md-6 mt_2">
                      <label for="exampleInputEmail1" className="form-label">
                        Created On
                      </label>
                      <input
                        type="text"
                        disabled
                        value={dateFormatter(
                          selectedUserDetailApprove?.createdOn
                        )}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-md-6 mt_2">
                      <label for="exampleInputEmail1" className="form-label">
                        Language
                      </label>
                      <input
                        type="text"
                        disabled
                        value={selectedUserDetailApprove?.lang}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="col-md-6 mt_2">
                      <label for="exampleInputEmail1" className="form-label">
                        Unicode
                      </label>
                      <input
                        type="text"
                        disabled
                        value={
                          selectedUserDetailApprove?.unicode == 0 ? false : true
                        }
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-md-12">
                      <label className="text-start">Template</label>
                      <TextareaAutosize
                        className="form-control w-100"
                        value={selectedUserDetailApprove?.templateDescription}
                        disabled
                        name="templateDesc"
                        fullWidth
                        aria-label="minimum height"
                        minRows={5}
                        //   style={{ minHeight: "150px" }}

                        placeholder="Enter Template"
                      />
                    </div>
                  </div>
                </div>

                <div className="modal-footer justify-content-between">
                  <button
                    type="button"
                    id="close_edit1"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      setSelectedUserDetailApprove(null);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      approveUserApi();
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container-fluid">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <div className="card mb-3 mt-4">
          <div className="card-header p-3 pt-2">
            <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
              {/* <i className="material-icons ttl_icon opacity-10">person</i> */}
              <PersonIcon
                style={{
                  color: "white",
                  fontSize: "27px",
                }}
              />
            </div>

            <div className=" marginleft_0 pt-1 ">
              <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
                View Templates
              </p>
            </div>
          </div>
          <div className="card-body">
            <ul className="nav nav-tabs mt-4" id="myTab" role="tablist">
           
              <li
                onClick={(e) => {
                  setFilter({
                    ...filter,
                    approveType: 1,
                  });
                }}
                className="nav-item ms-4"
                role="presentation"
              >
                <button
                  // className="nav-link position-relative"
                  className={
                    filter.approveType == 1
                      ? "nav-link active position-relative"
                      : "nav-link position-relative"
                  }
                  id="SenderMasking-tab1"
                  data-bs-toggle="SenderMaskingtab"
                  data-bs-target="#SenderMaskingtab"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  // aria-selected="false"
                  aria-selected={filter.approveType == 1 ? true : false}
                >
                  {/* <span className="position-absolute spn_8 top-0 start-100 translate-middle badge rounded-pill bg-danger">
             
                  <span className="visually-hidden">unread messages</span>
                </span> */}
                  Approved
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">
                    {count?.success == undefined ? 0 : count?.success}
                  </span>
                </button>
              </li>
              <li
                onClick={(e) => {
                  setFilter({
                    ...filter,
                    approveType: 0,
                  });
                }}
                className="nav-item ms-4"
                role="presentation"
              >
                <button
                  // className="nav-link active position-relative"
                  className={
                    filter.approveType == 0
                      ? "nav-link ms-4 active  position-relative"
                      : filter.approveType == undefined
                      ? "nav-link ms-4 active  position-relative"
                      : "nav-link ms-4   position-relative"
                  }
                  id="AccountDetails-tab"
                  data-bs-toggle="AccountDetailstab"
                  data-bs-target="#AccountDetailstab"
                  type="button"
                  role="tab"
                  // value={0}
                  aria-controls="AccountDetails"
                  // aria-selected="true"
                  aria-selected={
                    filter.approveType == 0
                      ? true
                      : filter.approveType == undefined
                      ? true
                      : false
                  }
                >
                  Pending
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning">
                    {/* {count?.pending == null ? 0 : count?.pending} */}
                    {count?.pending == undefined ? 0 : count?.pending}
                  </span>
                </button>
              </li>
              <li
                onClick={(e) => {
                  setFilter({
                    ...filter,
                    approveType: 2,
                  });
                }}
                className="nav-item ms-4"
                role="presentation"
              >
                <button
                  // className="nav-link position-relative"
                  className={
                    filter.approveType == 2
                      ? "nav-link active position-relative"
                      : "nav-link position-relative"
                  }
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  // aria-selected="false"
                  aria-selected={filter.approveType == 2 ? true : false}
                >
                  Rejected
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {count?.failed == undefined ? 0 : count?.failed}
                  </span>
                </button>
              </li>

              {/* <div className="col">
                <label>Show All :-</label>
                <div>
                  <input type="radio" id="huey" name="drone" value="huey" />
                  <label for="huey">Admin</label>
                </div>

                <div>
                  <input type="radio" id="dewey" name="drone" value="dewey" />
                  <label for="dewey">Users</label>
                </div>

                <div>
                  <input type="radio" id="louie" name="drone" value="louie" />
                  <label for="louie">Resellers</label>
                </div>
              </div> */}
            </ul>

            <div className="d-flex flex-wrap justify-content-between my-3">
              {filter.hideShow && (
                <>
                  <div className="d-flex me-3" style={{ width: "200px" }}>
                    <FormControl fullWidth>
                      <InputLabel size="small" id="test-select-label">
                        Select Search Category
                      </InputLabel>
                      <Select
                        size="small"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={filter.selectorType}
                        label="Select Search Category"
                        onChange={(e) => {
                          setFilter({
                            ...filter,
                            selectorType: e.target.value,
                            type: null,
                            resellerName: "",
                          });
                        }}
                      >
                        {[
                          {
                            id: 1,
                            name: "Template Name",
                            value: "Template Name",
                          },
                          {
                            id: 2,
                            name: "Type",
                            value: "Type",
                          },
                        ].map((d) => {
                          return <MenuItem value={d.value}> {d.name}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </div>

                  <div className="d-flex">
                    {filter.selectorType == "Template Name" ? (
                      <div
                        className="d-flex justify-content-between mx-3"
                        style={{ width: "300px" }}
                      >
                        <TextField
                          required
                          className="w-100"
                          label="Enter Template Name"
                          name="senderId"
                          variant="outlined"
                          size="small"
                          type="text"
                          value={filter.resellerName}
                          onChange={(e) => {
                            setFilter({
                              ...filter,
                              resellerName: e.target.value,
                            });
                          }}
                        />
                      </div>
                    ) : null}

                    {filter.selectorType == "Type" ? (
                      <div
                        className="d-flex justify-content-between mx-3"
                        style={{ width: "300px" }}
                      >
                        <FormControl fullWidth>
                          <InputLabel size="small" id="test-select-label">
                            Select Type
                          </InputLabel>
                          <Select
                            size="small"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={filter.type}
                            label="Select Type"
                            onChange={(e) => {
                              setFilter({
                                ...filter,
                                type: e.target.value,
                              });
                            }}
                          >
                            {[
                              { id: 0, name: "All", value: null },
                              {
                                id: 1,
                                name: "Promotional",
                                value: "Promotional",
                              },
                              {
                                id: 2,
                                name: "Transactional",
                                value: "Transactional",
                              },
                            ].map((d) => {
                              return (
                                <MenuItem value={d.value}> {d.name}</MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </div>
                    ) : null}

                    <div className="d-flex justify-content-between">
                      <button
                        disabled={
                          filter.type == null &&
                          (filter.resellerName == null ||
                            filter.resellerName == "")
                        }
                        onClick={fetchUser}
                        className={
                          filter.type == null &&
                          (filter.resellerName == null ||
                            filter.resellerName == "")
                            ? "btn btn-secondary"
                            : "btn btn-primary"
                        }
                        style={{ fontSize: "13px", boxShadow: "none" }}
                      >
                        Filter
                      </button>
                    </div>
                  </div>
                </>
              )}

              <div className="text-end" style={{ flexGrow: "1" }}>
                <IconButton
                  variant="text"
                  size="small"
                  sx={{
                    color: "#7B809A",
                  }}
                  onClick={(event) => {
                    setFilter({
                      ...filter,
                      hideShow: !filter.hideShow,
                    });
                  }}
                >
                  {filter.hideShow ? <CancelIcon /> : <SearchIcon />}
                </IconButton>
              </div>
            </div>
            {data.length > 0 ? (
              <>
                <div className="card-body">
                  {filter.hideShow && (
                    <div className="d-flex justify-content-between my-3">
                      <select
                        value={filter.pageSize}
                        className="dropdown"
                        onChange={(e) => {
                          setPageSize(Number(e.target.value));
                          setFilter({
                            ...filter,
                            pageSize: e.target.value,
                          });
                        }}
                      >
                        {[10, 25, 50].map((value, i) => {
                          return (
                            <option
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                              value={value}
                              key={value}
                            >
                              Show {value}
                            </option>
                          );
                        })}
                      </select>

                      <div className="d-flex align-items-center"></div>
                    </div>
                  )}

                  <div className="text-end">
                    {selectedFlatRows.length > 0 && (
                      <button
                        onClick={deletUser}
                        className="btn bg-gradient-primary m-0"
                      >
                        Delete Users
                      </button>
                    )}
                  </div>
                  <div className="table_overFlow">
                    <table
                      {...getTableProps()}
                      id="example"
                      className="table table-striped table-bordered dataTable table-sm mt-3"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        {headerGroups.map((headerGroup) => (
                          <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                              <th
                                {...column.getHeaderProps(
                                  column.getSortByToggleProps()
                                )}
                                className="text-center width_2"
                              >
                                {column.render("Header")}
                                <span>
                                  {column.isSorted
                                    ? column.isSortedDesc
                                      ? "↑"
                                      : "↓"
                                    : ""}
                                </span>
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <tr {...row.getRowProps()}>
                              {row.cells.map((cell) => {
                                return (
                                  <td
                                    {...cell.getCellProps()}
                                    // className={
                                    //   cell.column.Header == "User-Action" ||
                                    //   cell.column.Header == "Status"
                                    //     ? "text-center"
                                    //     : "text-start"
                                    // }
                                    //     className={
                                    //   (cell.column.Header == "Id" ||
                                    //     cell.column.Header == "Date" ) &&
                                    //   "text-end"
                                    // }

                                    className={
                                      cell.column.Header == "Id" ||
                                      cell.column.Header == "Date"
                                        ? "text-end"
                                        : cell.column.Header == "Status" ||
                                          cell.column.Header == "Action" ||
                                          cell.column.Header == "Unicode"
                                        ? "text-center"
                                        : "text-start"
                                    }
                                  >
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between mt-3">
                    <div>
                      <span>
                        Page:
                        <strong>
                          {data3?.pageable?.pageNumber + 1} of{" "}
                          {data3?.totalPages}
                        </strong>
                      </span>
                    </div>

                    <div>
                      <button
                        className="btn btn_primary "
                        type="button"
                        style={{ background: "#2C97D4" }}
                        disabled={data3?.pageable?.pageNumber == 0}
                        onClick={() => {
                          setFilter({
                            ...filter,
                            pageNo: filter.pageNo - 1,
                          });
                        }}
                      >
                        Prev
                      </button>

                      <button
                        className="btn btn_primary ms-2"
                        type="button"
                        style={{ background: "#2C97D4" }}
                        disabled={
                          data3?.totalPages == data3?.pageable?.pageNumber + 1
                        }
                        onClick={() => {
                          setFilter({
                            ...filter,
                            pageNo: filter.pageNo + 1,
                          });
                        }}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {data?.length == 0 && open ? null : (
                  <div className="text-center">
                    <h5>Data Not Found</h5>
                  </div>
                )}
              </>
            )}

            {/* <div className="d-flex mb-3 me-3">
              <div className="d-flex main_box">
                <p className="fw-bold">Add Template</p>
                <Link
                  to="/dashboard/CreateTemplate"
                  style={{ color: "#63B7E6", marginLeft: "30px" }}
                >
                  <span className="fw-bold">Click here !!!</span>
                </Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </main>
  );
}
